<template>
    <div class="part">
        <div class="center-text">
            <p class="part-title">{{ $t("Choose your Destination") }}</p>
            <div class="areas">
                <search-box
                    v-show="!loading"
                    :placeholder="$t('From')"
                    :data="citiesOptions"
                    @input="handleFromCitySelect($event)"
                    name="city"
                    class="basic-select"
                    :capitalize="false"
                    :isGetByID="true"
                    :required="true"
                ></search-box>
                <br />
                <br />
                <search-box
                    v-show="!loading"
                    :placeholder="$t('To')"
                    :data="citiesOptions"
                    @input="handleToCitySelect($event)"
                    name="city"
                    class="basic-select"
                    :capitalize="false"
                    :isGetByID="true"
                    :required="true"
                ></search-box>
            </div>
            <p style="margin-top: 35px">
                {{ $t("Add the estimated weight") }}
            </p>
            <div class="weight-area">
                <div class="level">
                    <div class="level-item">
                        <span class="dim">{{ $t("kg") }}</span>
                        <span
                            class="operator"
                            @click="
                                estimateWeight != 0 ? estimateWeight-- : null
                            "
                            >-</span
                        >
                        <span class="weight-number">
                            <input
                                type="number"
                                v-model.lazy="estimateWeight"
                                v-debounce="1000"
                            />
                        </span>
                        <span class="operator" @click="estimateWeight++"
                            >+</span
                        >
                    </div>
                </div>
            </div>
            <div v-if="loading" class="mb-5">
                <Loading />
                <span>{{ $t("Calculating...") }}</span>
            </div>
            <div v-else class="price">{{ totalProcessPrice }}</div>
            <span class="error" v-if="showErrorMsg">
                {{ showErrorMsg }}
                <br />
            </span>
            <br />
            <router-link to="/send-shipment" class="button is-primary">
                {{ $t("Start your shipping process") }}
            </router-link>
        </div>
    </div>
</template>

<script>
import searchBox from "@/components/searchBox.vue";
import Loading from "@/components/Loading";
import debounce from "v-debounce";
export default {
    name: "Domestic",
    components: {
        searchBox,
        Loading,
    },
    data() {
        return {
            fromCity: 0,
            toCity: 0,
            estimateWeight: 0,
            totalProcessPrice: 0,
            loading: false,
            showErrorMsg: null,
        };
    },
    computed: {
        options() {
            return this.$store.state.countries;
        },
        citiesOptions() {
            return this.$store.state.citiesSearchResults;
        },
    },
    watch: {
        estimateWeight: {
            handler(val) {
                if (val) {
                    if (!this.fromCity || !this.toCity) {
                        this.$buefy.toast.open({
                            message: this.$t(
                                "Please choose the destinations correctly"
                            ),
                            type: "is-primary",
                        });
                        return (this.estimateWeight = 0);
                    }
                    this.domesticRateReq();
                }
            },
        },
        fromCity: {
            handler(val) {
                this.estimateWeight = 0;
            },
        },
        toCity: {
            handler(val) {
                this.estimateWeight = 0;
            },
        },
    },
    created() {
        this.$store.dispatch("citiesHandlers", {
            country: 187,
        });
    },
    methods: {
        domesticRateReq() {
            this.loading = true;
            this.showErrorMsg = null;
            this.$store
                .dispatch("domesticRateReq", {
                    from_city: this.fromCity.name,
                    to_city: this.toCity.name,
                    weight: this.estimateWeight,
                })
                .then((res) => {
                    this.totalProcessPrice = res.data.data;
                })
                .catch((e) => {
                    this.showErrorMsg = e.data.response.data.message;
                })
                .finally(() => (this.loading = false));
        },
        handleFromCitySelect(e) {
            if (e.length > 0) {
                this.updateCityHandlers(e, 187);
            } else {
                this.fromCity = e;
            }
        },
        handleToCitySelect(e) {
            if (e.length > 0) {
                this.updateCityHandlers(e, 187);
            } else {
                this.toCity = e;
            }
        },
        updateCityHandlers(e, countryID) {
            this.$store.dispatch("citiesHandlers", {
                keyword: e,
                country: countryID,
            });
        },
    },
    directives: {
        debounce,
    },
};
</script>

<style lang="scss" scoped>
.part {
    width: 100%;
    height: 100%;
    text-align: center;

    .part-title {
        text-align: left;

        &:lang(ar) {
            text-align: right;
        }
    }

    p {
        font-weight: bold;
        font-size: 1.2rem;
    }

    .center-text {
        text-align: center;
    }

    .areas {
        background-color: #f5f5f5;
        padding: 15px 0;
        margin: 20px 0;

        ::v-deep {
            input,
            .select select {
                background-color: transparent;
                border-color: transparent !important;
                outline: none !important;
            }

            .basic-select {
                display: inline-block;
                width: 80%;
                position: relative;
                vertical-align: top;

                .select-head {
                    span {
                        background: #f5f5f5;
                    }
                }
            }
        }
    }

    .weight-area {
        position: relative;
        background-color: #f5f5f5;
        padding: 10px;
        margin: 15px 0 30px 0;
        display: inline-block;
        width: 220px;

        span {
            display: inline-block;
        }

        .dim {
            position: absolute;
            bottom: -1px;
            left: 46%;
        }

        .weight-number {
            min-width: 100px;
            font-size: 2rem;

            input {
                background: none;
                text-align: center;
                font-size: inherit;
                width: 100px;
                outline: 0;
            }
        }

        .operator {
            font-size: 1.6rem;
            font-weight: bold;
            cursor: pointer;
        }
    }

    .price {
        font-size: 2.2rem;
        color: black;
        position: relative;
        margin: 20px 0 50px 0;

        &::before {
            content: "SAR";
            position: absolute;
            display: inline-block;
            right: calc(50% - 50px);
            top: 100%;
            font-size: 0.85rem;
            color: #8c8c8c;
        }
    }
}

.button {
    border-radius: 3px !important;
    width: 250px;
}

.error {
    color: red;
}
</style>
